import PropTypes from 'prop-types';
import React from 'react';
import { Flex } from 'roo-ui/components';

const ContentRow = ({ children, ...rest }) => (
  <Flex
    flexDirection="row"
    justifyContent={['space-between', 'flex-start']}
    mb={[4, 0]}
    {...rest}
    data-print-style="content-row"
    data-testid="content-row"
  >
    {children}
  </Flex>
);

ContentRow.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
};

ContentRow.displayName = 'ContentRow';

export default ContentRow;
